import { DefaultConfigProps } from 'types/config';

export const drawerWidth = 260;

export const DEFAULT_PATH = '/signup-wizard';
export const VERSION = process.env.NEXT_PUBLIC_APP_VERSION ?? '';
export const BASE_API = '/service';
export const BASE_PATH = '';
export const KEY_MAP = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY ?? '';

const config: DefaultConfigProps = {
  fontFamily: `'Prompt','Inter', sans-serif`,
  i18n: 'th',
  miniDrawer: false,
  container: true,
  mode: 'light',
  presetColor: 'theme1',
  themeDirection: 'ltr'
};

export default config;
